<template>
  <div class="campaigns-page">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
    </breadcrumbs>
    <div class="warp content-wrapper">
      <LeftFilterPanel :categoryMaxLevel="1" ref="leftFilterPanelRef" :filter="filter"
        :category-collapsed="categoryCollapsed" :brand-collapsed="brandCollapsed"
        :is-searching-brands="isSearchingBrands" :brand-search="brandSearch" :brands="brands"
        :is-loading-brands="isLoadingBrands" :set-category="setCategory" :collapse="collapse"
        :get-brands-list="getBrandsList" :load-more-brands="loadMoreBrands" :set-filter="setFilter" />
      <div class="right-content">
        <RightContent :leftFilter="filter" />
      </div>
    </div>

  </div>
</template>

<script setup>
import { nextTick, onMounted, ref } from 'vue'
import debounce from 'lodash/debounce'
import LeftFilterPanel from '@/pages/publisher/products/components/LeftFilterPanel.vue'
import { publisherApi } from '@/server'
import RightContent from './components/rightContent.vue'
import breadcrumbs from '@/components/breadcrumbs.vue'
const leftFilterPanelRef = ref(null)
const categoryCollapsed = ref(false)
const brandCollapsed = ref(false)
const isSearchingBrands = ref(false)
const isLoadingBrands = ref(false)
const hasQuery = ref(false)
const breadcrumbsData = {
  title: "Open CPC Campaigns",
  color: "#26AADC",
  hasTitleIcon: false,
  // des: `Open CPC Campaigns`,
  links: [
    {
      name: "Home",
      path: "/publisher/dashboard",
    },
    {
      name: "Campaigns",
      path: "/publisher/campaigns/index",
    },
    {
      name: "Open CPC Campaigns",
      path: "/publisher/campaigns/index",
    },
  ],
}
const filter = ref({
  page: 1,
  size: 20,
  countryCode: 'US',
  selectedBrands: [],
  categoryId: null,
  categoryLevel: null,
  categoryName: 'All',
})

const brandSearch = ref({
  page: 1,
  size: 10,
  total: 0,
  brandName: '',
})

const brands = ref([])

const collapse = (type) => {
  if (type === 'category') {
    categoryCollapsed.value = !categoryCollapsed.value
  } else {
    brandCollapsed.value = !brandCollapsed.value
  }
}

function getCampaignsList () {
  // TODO: 接入 campaigns 列表查询
}

function getBrandsList (event) {
  const keywords = event ? event.target.value : undefined

  if (keywords !== undefined) {
    brandSearch.value.page = 1
    isSearchingBrands.value = true
    brandSearch.value.brandName = keywords
  } else {
    isLoadingBrands.value = true
  }

  const params = {
    ...brandSearch.value,
    countryCode: filter.value.countryCode,
  }

  if (params.brandName) {
    params.brandName = encodeURIComponent(params.brandName)
  }

  publisherApi
    .getBrandsList(params)
    .then((res) => {
      const result = (res.data || []).map((item) => ({
        ...item,
        selected: hasQuery.value ? true : false,
      }))

      if (brandSearch.value.page === 1) {
        brandSearch.value.total = res.total || 0

        if (keywords !== undefined) {
          const filterSelectedBrands = filter.value.selectedBrands.filter((brand) =>
            brand.brandName.toLowerCase().includes(keywords.toLowerCase()),
          )

          brands.value = [
            ...filterSelectedBrands,
            ...result.filter(
              (item) =>
                !filterSelectedBrands.some((selected) => selected.brandName === item.brandName),
            ),
          ]
        } else {
          brands.value = result
        }
      } else {
        brands.value = [...brands.value, ...result]
      }
      hasQuery.value = false
    })
    .catch(() => {
      if (brandSearch.value.page === 1) {
        brands.value = []
      }
    })
    .finally(() => {
      if (keywords !== undefined) {
        isSearchingBrands.value = false
      } else {
        isLoadingBrands.value = false
      }
    })
}

function setFilter (type, option) {

  if (type === 'page') {
    filter.value.page = option
  } else if (type === 'brand') {
    if (!option.remove) {
      if (option.selected) {
        filter.value.selectedBrands = filter.value.selectedBrands.filter(
          (brand) => brand.brandName !== option.brandName,
        )
        brands.value[option.index].selected = false
      } else {
        filter.value.selectedBrands.push({ ...option, selected: true })
        brands.value[option.index].selected = true
      }
    } else {
      filter.value.selectedBrands = filter.value.selectedBrands.filter(
        (item) => item.brandName !== option.brandName,
      )
      const index = brands.value.findIndex((item) => item.brandName === option.brandName)
      if (index >= 0) {
        brands.value[index].selected = false
      }
    }
    filter.value.page = 1
  } else if (type === 'category') {
    filter.value = {
      ...filter.value,
      ...option,
      page: 1,
    }
  }

  // getCampaignsList()
  nextTick(() => { })
}

function setCategory (category) {

  if (category?.categoryId) {
    const { categoryId, displayName, level } = category
    filter.value.categoryLevel = level
    filter.value.categoryId = categoryId
    filter.value.categoryName = displayName
  } else {
    filter.value.categoryId = null
    filter.value.categoryLevel = null
    filter.value.categoryName = 'All'
    leftFilterPanelRef.value?.getCategories({ categoryId: 0, level: 1 })
  }

}

const loadMoreBrands = debounce((e) => {
  const { scrollTop, scrollHeight, clientHeight } = e.target
  if (clientHeight + scrollTop >= scrollHeight - 50) {
    if (brandSearch.value.total > brandSearch.value.page * brandSearch.value.size) {
      brandSearch.value.page += 1
      getBrandsList()
    }
  }
}, 300)

onMounted(() => {
  getBrandsList()
})
</script>
<style scoped lang="less">
.campaigns-page {

  .warp {
    display: flex;
  }
}

.right-content {
  flex: 1;
  width: 100%;
}
</style>